import axios, {AxiosResponse} from 'axios';
import {IStatistics} from '../staistics-dashboard/interfaces';

export const getDashboardStatisticsApi = (userGroupId: number | null, from?: string, to?: string): Promise<AxiosResponse<IStatistics>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/chatroom/conversation/dashboard`,
    {
      params: {
        dateB: from,
        dateE: to,
        userGroupId: userGroupId
      }
    }
  );
};
